<template>
  <div>
    <locker-form-dialog
      ref="lockerFormDialog"
      :data="dialog.locker.data"
      :gender="gender"
      :enrollment-id="enrollmentId"
      :is-dialog-visible.sync="dialog.locker.isVisible"
      @update="onUpdateLockerData"
    />
    <el-table
      v-if="lockerHistories.length"
      v-loading="loading"
      :data="lockerHistories"
      class="fifl-main-table"
      header-row-class-name="fifl-table-header-row"
      header-cell-class-name="fifl-table-header-cell"
      cell-class-name="fifl-main-table-cell"
      :span-method="tableSpanRule"
    >
      <el-table-column
        label="락커"
        prop="room.name"
        fixed="left"
        width="100"
      />
      <el-table-column
        label="시작일"
        prop="start"
        width="60"
      >
        <template slot-scope="scope">
          {{ formatStartEndDates(scope.row.start, scope.row.duration) }}
        </template>
      </el-table-column>
      <el-table-column
        label="종료일"
        prop="duration"
        width="60"
      />
      <el-table-column />
      <el-table-column
        label="결제 금액"
        width="80"
      >
        <template slot-scope="scope">
          {{ numberWithCommas(scope.row.card + scope.row.cash + scope.row.remainder) }}
        </template>
      </el-table-column>
      <el-table-column
        label="카드"
        width="70"
      >
      <template slot-scope="scope">
        {{ numberWithCommas(scope.row.card) }}
      </template>
      </el-table-column>
      <el-table-column
        label="현금"
        width="70"
      >
        <template slot-scope="scope">
          {{ numberWithCommas(scope.row.cash) }}
        </template>
      </el-table-column>
      <el-table-column
        label="미수금"
        prop="remainder"
        width="70"
      >
        <template slot-scope="scope">
          {{ numberWithCommas(scope.row.remainder) }}
        </template>
      </el-table-column>
      <el-table-column
        label="결제일"
        prop="paied_at"
        width="80"
      >
        <template slot-scope="scope">
          {{ scope.row.paid_at ? format(scope.row.paid_at, 'YY.MM.DD') : '-' }}
        </template>
      </el-table-column>
      <el-table-column
        label=""
        width="50"
        fixed="right"
        class-name="more-action__column"
      >
        <template slot-scope="scope">
          <more-action-dropdown
            :payload-data="scope.row"
            :dropdown-items="lockerDropdownItems"
            @command="handleLockerRowAction"
          />
        </template>
      </el-table-column>
    </el-table>
    <empty-table 
      v-else
      :props-loading-status="loading"
      :props-has-parent="emptyTableProps.hasParent"
      :props-is-icon="emptyTableProps.isIcon"
      :props-header-height="emptyTableProps.headerHeight"
      :props-data="emptyTableProps.data"
      :props-table-body-height="emptyTableProps.bodyHeight"
      :props-message="emptyTableProps.message" 
    />
    <div class="member-detail-table-control">
      <el-button
        class="calendar icon-word-btn ic-plus"
        @click="handleLockerDialogToAdd"
      >
        락커 추가
      </el-button>
    </div>
  </div>
</template>

<script>
import EmptyTable from "@/components/EmptyTable"
import LockerFormDialog from "./LockerFormDialog";
import MoreActionDropdown from "@/components/MoreActionDropdown";
import dateFns from "date-fns";
import { fiflboxApi } from '@/utils/api';
import { numberWithCommas } from '@/utils/etc'

const lockerDropdownItems = [
	{
		action: "modify",
		label: "수정",
	},
	{
		action: "delete",
		label: "취소",
	},
];

export default {
	name: "MemberDetailLockerTable",
	components: { EmptyTable, MoreActionDropdown, LockerFormDialog },
	props: ["enrollmentId", "gender"],
	data() {
		return {
			lockerHistories: [],
      lockerDropdownItems,
      loading : false,
      emptyTableProps: {
        message : '이용 중인 락커가 없습니다.',
        bodyHeight: 335,
        headerHeight:51,
        hasParent:false,
        isIcon:true,
        data :  [
          {label:"락커", width:100+'px'},
          {label:"시작일", width:60+'px'},
          {label:"종료일", width:60+'px'},
          {label:"", width: 'calc(100% - 640px)'},
          {label:"결제 금액", width:80+'px'},
          {label:"카드", width:70+'px'},
          {label:"현금", width:70+'px'},
          {label:"미수금", width:70+'px'},
          {label:"결제일", width:80+'px'},
          {label:"", width:50+'px'}
        ]
      },
			dialog: {
				locker: {
					isVisible: false,
					data: null,
				},
			},
		};
	},
	computed: {},
	created() {
    this.loading = true
		this.syncLockerData();
	},
	methods: {
		format: dateFns.format,
    numberWithCommas,
		tableSpanRule({ row, column, rowIndex, columnIndex }) {
			if (column.property === "type") {
				return [0, 0];
			}

			if (columnIndex === 1) {
				return [1, 2];
			}

			if (columnIndex === 2) {
				return [0, 0];
			}
		},
		formatStartEndDates(start, duration) {
			let end = dateFns.addDays(start, duration);
			return `${dateFns.format(start, "YY.MM.DD")} - ${dateFns.format(
				end,
				"YY.MM.DD"
			)}`;
		},
		async syncLockerData() {
			try {
        let { data: lockerHistories } = await fiflboxApi.v1.getLockerHistories({
          enrollment: this.enrollmentId
        })

				this.lockerHistories = lockerHistories;
        this.loading = false;
			} catch (err) {}
		},
		handleLockerDialogToAdd() {
			this.$refs["lockerFormDialog"].openDialogToAdd({
				enrollmentId: this.enrollmentId,
			});
		},
		handleLockerDialogToModify(data) {
      this.$refs["lockerFormDialog"].openDialogToModify(data);
      this.loading = false
		},
    async onUpdateLockerData() {
		  await this.syncLockerData();
      this.$emit('update');
      this.loading = false
    },
		async handleLockerRowAction({ action, data }) {
      this.loading = true
			if (action === "modify") {
				let lockerData = this.lockerHistories.find(
					locker => locker.id === data.id
				);
				this.handleLockerDialogToModify(lockerData);
			} else if (action === "delete") {
        await fiflboxApi.v1.deleteLockerHistories(data.id);
				this.onUpdateLockerData();
      }
		},
	},
};
</script>

<style lang="scss">
</style>
